import { createAction } from '@reduxjs/toolkit'

export const exportSurvey = createAction<{ id: string; name: string }>('survey/exportSurvey')
export const exportAllSurvey = createAction('survey/exportAllSurvey')
